import { DEFAULT_LOCALE, I18nResources } from '@longy/common'
import type { Resource } from 'i18next'
import i18n from 'i18next'
import { I18nextProvider, initReactI18next } from 'react-i18next'

import { api } from '../core/trpc'
import { resolveInitialLocale } from '../utils/locale'

declare module 'i18next' {
    interface CustomTypeOptions {
        resources: I18nResources
    }
}

export const TranslationProvider = ({ children }: { children: React.ReactNode }) => {
    const { data: translationJson } = api.translation.getJson.useQuery()

    if (!i18n.isInitialized && translationJson) {
        i18n.use(initReactI18next).init({
            // `resolveInitialLocale` reads what the visitor last chose. It is client-only by
            // design: the server has no per-request access to that choice here, and rendering the
            // default on the server keeps every SSR pass identical — the client then switches on
            // hydration for anyone who picked English.
            lng: resolveInitialLocale(),
            fallbackLng: DEFAULT_LOCALE,
            resources: translationJson as Resource,
            nsSeparator: '.',
            initImmediate: false,
        })
    }

    return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>
}
